import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

export const fetchData = createAsyncThunk("fetchData", async function () {
    const response = await fetch(
        "https://commodities-api.com/api/latest?access_key=2io44hde9b6qqs2zj046i24v51w1l8s9pt1kfh41baku3t2wh7hbl7o83vx6&base=USD&symbols=%2CWTIOIL%2CBRENTOIL%2CCOFFEE%2CCOAL"
    )
    const data = await response.json()
    return data
})

const initialState = []

export const getDataReducer = createSlice({
    name: "weatherData",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchData.fulfilled, (state, action) => {
            state.splice(0, state.length)
            state.push(action.payload)
        })
    },
})

export default getDataReducer.reducer
